import React, { useState } from 'react'
import { Button, Row, Col, Form, Spinner } from 'react-bootstrap'
import useFormvalidation from '../validations/FormValidation';
import { ContactFormRules } from '../validations/FormValidationRules';
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { useMediaQuery } from 'react-responsive';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {  toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { FaRegCalendar } from "react-icons/fa";
import Apis from '../services/Apis'

import { useDispatch } from 'react-redux';
import {
    setToggleFalse,
    setDownloadBrochureFalse
} from '../redux/slice/changeState';

const ContactForm = ({ downloadBrochure }) => {
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
    const { saveContactFormdata } = Apis()
    const [date, setDate] = useState(null);
    const [loader, setLoader] = useState(false)
    const [formValues, setFormValues] = useState(
        {
            "name": "",
            "phone": "",
            "email": "",
            "message": "",
            "source": "Miracle",
        }
    );

    const notify = (msz) => {
        toast(msz)
    }

    // const handleNext = async () => {
    //     setLoader(true);

    //     try {
    //         const payload = {
    //             ...values,
    //         };

    //         const res = await saveContactFormdata(payload);

    //         if (res.status === 200) {
    //
    //             notify("Form submitted successfully!");

    //
    //             if (downloadBrochure) {
    //                 const pdfFile = isMobile
    //                     ? "/miracle.pdf"
    //                     : "/Miracle.pdf";

    //                 const link = document.createElement("a");
    //                 link.href = pdfFile;
    //                 link.download = pdfFile.split("/").pop();

    //                 document.body.appendChild(link);
    //                 link.click();
    //                 document.body.removeChild(link);

    //             }
    //             dispatch(setDownloadBrochureFalse());

    //             dispatch(setToggleFalse());

    //             //  reset form
    //             setValues({
    //                 name: "",
    //                 phone: "",
    //                 email: "",
    //                 message: "",
    //                 source: "",
    //                 consent: false,
    //             });

    //             setDate(null);

    //             // setTimeout(() => {
    //             //   onSuccess?.();
    //             // }, 800);
    //         }
    //     } catch (err) {
    //         console.error(err);
    //         notify("Something went wrong.");
    //         setValues({
    //             name: "",
    //             phone: "",
    //             email: "",
    //             message: "",
    //             source: "",
    //             consent: false,
    //         });
    //     } finally {
    //         setLoader(false);
    //     }
    // };

    const handleNext = async () => {
        setLoader(true);

        try {
            const payload = {
                ...values,
            };

            const res = await saveContactFormdata(payload);

            if (res?.status === 200) {
                notify("Form submitted successfully!");

                if (downloadBrochure) {

                    const pdfFile = isMobile
                        ? "/miracle.pdf"
                        : "/Miracle.pdf";
                    const link = document.createElement("a");
                    link.href = pdfFile;
                    link.download = pdfFile.split("/").pop();

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }

                dispatch(setDownloadBrochureFalse());
                dispatch(setToggleFalse());

                setValues({
                    name: "",
                    phone: "",
                    email: "",
                    message: "",
                    source: "",
                    consent: false,
                });

                setDate(null);
            } else {
            }

        } catch (err) {

            notify("Something went wrong.");

            setValues({
                name: "",
                phone: "",
                email: "",
                message: "",
                source: "",
                consent: false,
            });

        } finally {
            setLoader(false);
        }
    };

    const { values, setValues, errors, setErrors, handleChange, handleSubmit } = useFormvalidation(
        handleNext,
        ContactFormRules,
        formValues
    );

    const handleDate = (data) => {
        const formattedDate = moment(data).format('MM/DD/YYYY'); // Format the selected date
        setValues(values => ({ ...values, message: "Schedule Date is : " + formattedDate, source: "Miracle" }));
        setDate(formattedDate)
    }
    return (
        <>
            <Row className={`${!isMobile ? 'mb-4' : ''}`} style={{ paddingRight: isMobile ? '' : '' }}>
                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                    <Form.Control type="text" placeholder="Name" name="name" onChange={handleChange} value={values.name} autoComplete="new-item" />
                    <span className='error mt-3'>{errors.hasOwnProperty('name') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.name} </>}
                    </span>
                </Col>
                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                    <Form.Control type="email" placeholder="Email" name="email" onChange={handleChange} value={values.email} autoComplete="new-item" />
                    <span className='error mt-3'>{errors.hasOwnProperty('email') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.email} </>}
                    </span>
                </Col>
            </Row>
            <Row style={{ paddingRight: isMobile ? '' : '' }}>
                <Col lg={6} md={12} xs={12} className={`${isMobile ? 'mb-3' : ''}`}>
                    <Form.Control type="text" placeholder="Phone Number" name="phone" onChange={handleChange} value={values.phone} autoComplete="new-item" />
                    <span className='error mt-3'>{errors.hasOwnProperty('phone') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.phone} </>}
                    </span>
                </Col>
                <Col lg={6} md={12} xs={12}>
                    <div className='datepicker-container'>
                        <DatePicker selected={date ? new Date(date) : null} onChange={handleDate} className='custom-datepicker' placeholderText="Select Date" />
                        <FaRegCalendar className="calendar-icon" />
                    </div>
                    <span className='error mt-3'>{errors.hasOwnProperty('message') &&
                        <><AiOutlineExclamationCircle className="error-icon" style={{ marginRight: '6px' }} />{errors.message} </>}
                    </span>
                </Col>
            </Row>
            <Row className={`${isMobile ? 'mt-4' : 'mt-5'}`}>
                <Col>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                        <label className="form-check-label authorize-label" htmlFor="flexCheckChecked">
                            I authorize representatives of IRA Aspiration to Call, SMS, Email or WhatsApp me about its products and offers. This consent overrides any registration for DNC/NDNC.
                        </label>
                    </div>
                </Col>
            </Row>
            <button type="submit" className='common-btn schedule-button mt-3' onClick={handleSubmit}>Schedule a Visit {loader && <Spinner className='loader' animation="border" />}</button>
            {/* <ToastContainer /> */}
        </>
    )
}

export default ContactForm
